// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dVlW","footer":"styles_footer__3o_K4","passCodeTooltip":"styles_passCodeTooltip__gg3LD"};